"use client";

import { Typography } from "@drpcrd/shared/ui";
import { ReactNode } from "react";

type Props = {
  title: string;
  description?: string;
  panelImage: ReactNode;
  url?: string;
};

/**
 * InfoPanel displays an icon, title, and optional description in a styled panel that opens a URL when clicked.
 */
export const ImageInfoPanel = ({
  title,
  description,
  panelImage,
  url,
}: Props) => {
  const handleClick = () => {
    if (url) {
      window.open(url, url.startsWith("http") ? "_blank" : "_self");
    }
  };

  return (
    <div
      className="bg-bg-primary shadow-light max-w-22 flex cursor-pointer items-center rounded-lg px-0 py-0"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleClick();
        }
      }}
    >
      <div className="flex h-full w-full flex-col overflow-hidden rounded-lg">
        {panelImage}

        <div className="flex h-full flex-col overflow-hidden p-2">
          <Typography weight="bold">{title}</Typography>

          {description && (
            <Typography color="neutral" className="break-words">
              {description}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
};
